import { SPONSOR_CONTACT_URL } from "../config/events";

const cardClass =
  "rounded-xl border border-slate-800/80 bg-slate-900/40 px-5 py-5 text-left";

export const SponsorSection = () => {
  return (
    <section className={cardClass}>
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
        Sponsors
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-400">
        If you're a business that needs, values, or contributes to high social
        engagement — come talk to me about sponsorship. It's not a big lift, but
        we do look for partners who can help drive network engagement in the
        room.
      </p>
      {SPONSOR_CONTACT_URL ? (
        <a
          href={SPONSOR_CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex text-sm font-medium text-emerald-400 transition hover:text-emerald-300"
        >
          Talk about sponsoring →
        </a>
      ) : null}
    </section>
  );
};
